import dynamic from 'next/dynamic';
import { PLUGIN_NAME } from './constants';
import { COMPONENT_PREFIX } from './components/constants';
import translations, { overrideTranslations } from './translations';

export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: `${COMPONENT_PREFIX}registrationform`,
      component: dynamic(() =>
        import(/* webpackChunkName: "blazePbPpRegistrationForm" */ './components/RegistrationForm')
      )
    });
    addComponent({
      key: `${COMPONENT_PREFIX}userdetails`,
      component: dynamic(() =>
        import(/* webpackChunkName: "blazePbPpUserDetails" */ './components/UserDetails')
      )
    });
    addComponent({
      key: `${COMPONENT_PREFIX}aggregationcards`,
      component: dynamic(() =>
        import(/* webpackChunkName: "blazePbPpAggregationCards" */ './components/AggregationCards')
      )
    });
  });

  app.events.once('plugin:translation-fe:translations:load', loadTranslations =>
    loadTranslations(translations, PLUGIN_NAME)
  );

  app.events.once('plugin:translation-fe:translations:override', loadTranslations => {
    Object.entries(overrideTranslations).forEach(([namespace, translationsItems]) => {
      loadTranslations(translationsItems, namespace);
    });
  });

  return {
    name: PLUGIN_NAME
  };
}

load.pluginName = PLUGIN_NAME;
